export const loggingContexts = {
  acknowledge: "ACKNOWLEDGE",
  activate: "ACTIVATE",
  alert: "ALERT",
  alertState: "ALERT_STATE",
  autoClose: "AUTO_CLOSE",
  checkInstallerVersion: "CHECK_INSTALLER_VERSION",
  checkVersion: "CHECK_VERSION",
  incomingMessage: "INCOMING_MESSAGE",
  main: "MAIN",
  mainLoop: "MAIN_LOOP",
  mainMenu: "MAIN_MENU",
  notify: "NOTIFY",
  openExternalUrl: "OPEN_EXTERNAL_URL",
  pruneLogs: "PRUNE_LOGS",
  pubnubInstance: "PUBNUB_INSTANCE",
  pubnubListeners: "PUBNUB_LISTENERS",
  pubnubStatus: "PUBNUB_STATUS",
  receipts: "RECEIPTS",
  recover: "RECOVER",
  reportActivity: "REPORT_ACTIVITY",
  requestGroupSilence: "REQUEST_GROUP_SILENCE",
  setAlertAsDismissed: "SET_ALERT_AS_DISMISSED",
  silenceAlert: "SILENCE_ALERT",
  soundAlert: "SOUND_ALERT",
  startupShortcut: "STARTUP_SHORTCUT",
  uncaughtError: "UNCAUGHT_ERROR",
  userInteraction: "USER_INTERACTION",
};
